var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pagination mt-2"},[_c('li',{staticClass:"page-item previous disabled"},[_c('a',{staticClass:"page-link",attrs:{"href":"#","data-dt-idx":"0","tabindex":"0"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticClass:"page-item next disabled"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_vm._v(" ")])])])
}]

export { render, staticRenderFns }